import React, { useContext } from "react";
import { ConfinementMapDashboardContext } from "../../contexts/confinementMapDashboardContext";

export function useConfinementMapContext() {
  const values = useContext(ConfinementMapDashboardContext);

  return values;
}
